import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUserSession } from "../utils/userSession";

export default function ContactForm() {
    const savedSession = getUserSession();

    const [formData, setFormData] = useState({
      name: savedSession?.name || "",
      email: savedSession?.email || "",
      mobile: savedSession?.mobile || "",
      message: ""
    });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.mobile || !formData.email) {
    toast.error("Please fill all fields ❌");
    return;
  }

  try {
    const response = await fetch("https://biomefarms.com/api/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (data.status === "success") {
      toast.success("Form submitted successfully ✅");

      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: ""
      });
    } else {
      toast.error("Something went wrong ❌");
    }

  } catch (error) {
    toast.error("Server error ❌");
  }
};
    return (
        <section>
               <ToastContainer />
            <div className="biome-element biome-element-533a5fc e-con-full e-flex e-con e-parent e-lazyloaded">
                <div className="biome-element biome-element-2f3e8c0 biome-widget biome-widget-google_maps animated">
                    <div className="biome-widget-container">
                        <div className="biome-custom-embed">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.046362021932!2d77.5998737!3d12.9688852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae167892b16469%3A0xebd90c8496d75707!2sThe%20Presidency!5e0!3m2!1sen!2sin!4v1784698318091!5m2!1sen!2sin" width="600" height="450"  loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                        </div>
                    </div>
                </div>
            </div>
           
        </section>
    )}